import { withStyles } from '@material-ui/core';

import RemoveButton from './component';
import styles from './styles';

export default withStyles(styles)(RemoveButton);
